import cn from 'classnames';
import { useState } from 'react';
import ImageViewer from 'react-simple-image-viewer';
import { Column, Row } from '../../../../components/Basic/Blocks';
import { CheckButton } from '../../../../components/Basic/Buttons';
import { Input } from '../../../../components/Basic/Inputs';
import { HeaderTitle, Table, TableCell, TableHeader, TableLine } from '../../../../components/Basic/Table';
import ProviderList from '../../../../components/Common/Input/ProviderList';
import { formFullDate } from '../../../../utils';
import { WIDTH_OZON_ORDERS } from '../index';
import styles from '../styles.module.scss';
import { Text, TextGrey } from '../../../../components/Basic/WrapsStyle';

const OzonTableSizes = ({ groups = {}, select, map, onChange = () => { } }) => {
  const [isViewerOpen, setIsViewerOpen] = useState(false);
  const [images, setImages] = useState([]);

  const openImageViewer = (imgs) => {
    setImages(imgs);
    setIsViewerOpen(true);
  };
  const closeImageViewer = () => {
    setIsViewerOpen(false);
    setImages([]);
  };

  return (
    <>
      <Table styles={styles.ozon_table}>
        <TableHeader whiteHeader={true} styles={styles.table_line}>
          <HeaderTitle width={WIDTH_OZON_ORDERS[0]}>Номер заказа</HeaderTitle>
          <HeaderTitle width={WIDTH_OZON_ORDERS[1]}>Позиции в заказе</HeaderTitle>
          <HeaderTitle width={WIDTH_OZON_ORDERS[2]}>Артикул товара</HeaderTitle>
          <HeaderTitle width={WIDTH_OZON_ORDERS[7]} centerText>Длина, мм</HeaderTitle>
          <HeaderTitle width={WIDTH_OZON_ORDERS[7]} centerText>Высота, мм</HeaderTitle>
          <HeaderTitle width={WIDTH_OZON_ORDERS[7]} centerText>Ширина, мм</HeaderTitle>
          <HeaderTitle width={WIDTH_OZON_ORDERS[7]} centerText>
            Объем, л
          </HeaderTitle>
          <HeaderTitle width={WIDTH_OZON_ORDERS[7]} centerText />
          <HeaderTitle width={WIDTH_OZON_ORDERS[5]} centerText>
            Поставщик
          </HeaderTitle>
          <HeaderTitle width={WIDTH_OZON_ORDERS[6]} centerText>
            Артикул поставщика
          </HeaderTitle>
          <HeaderTitle width={WIDTH_OZON_ORDERS[6]} centerText>
            Количество в заказе
          </HeaderTitle>
          <HeaderTitle width={WIDTH_OZON_ORDERS[7]} centerText />
        </TableHeader>
        {(groups[select] || []).map((order) => {

          const mapByShop = map[order.shop]

          return (
            <TableLine key={order.posting_number}>
              <TableCell width={WIDTH_OZON_ORDERS[0]}>
                {order.posting_number} <TextGrey fontSize={14}>{formFullDate(order.in_process_at)}</TextGrey>
              </TableCell>
              <TableCell width={WIDTH_OZON_ORDERS[1]}>
                <Column>
                  {order.products.map((p, k) => {
                    const data = mapByShop[p.offer_id] || {};
                    const img = !!mapByShop[p.offer_id] ? data.images || [] : [];

                    return (
                      <div key={k} className={styles.div_line_images}>
                        <div className={styles.wrapper}>
                          <img
                            onClick={() => openImageViewer([img[0]])}
                            className={styles.preview}
                            src={img.length > 0 ? img[0] : undefined}
                          />
                        </div>
                        <div className={styles.name}>{`${p.quantity} x ${p.name}`}</div>
                      </div>
                    );
                  })}
                </Column>
              </TableCell>
              <TableCell width={WIDTH_OZON_ORDERS[2]}>
                <Column>
                  {order.products.map((p, k) => (
                    // eslint-disable-next-line react/no-array-index-key
                    <div key={`${p.offer_id}${k}`} className={styles.div_line}>
                      <Text className={!!mapByShop[p.offer_id] ? styles.green_text : styles.red_text}>{p.offer_id}</Text>
                    </div>
                  ))}
                </Column>
              </TableCell>

              <TableCell width={WIDTH_OZON_ORDERS[7]}>
                <Column>
                  {order.products.map((p, k) => (
                    // eslint-disable-next-line react/no-array-index-key
                    <Row
                      key={k}
                      className={cn(
                        styles.div_line,
                        mapByShop[p.offer_id]?.status_flags?.is_check_size && styles.div_line_green,
                      )}
                    >
                      <Input
                        value={((mapByShop[p.offer_id] || { sizes_package: {} }).sizes_package || {}).depth}
                        onBlur={(v) => onChange(p.offer_id, order.shop, 'depth', v)}
                        center
                      />
                    </Row>
                  ))}
                </Column>
              </TableCell>
              <TableCell width={WIDTH_OZON_ORDERS[7]}>
                <Column>
                  {order.products.map((p, k) => (
                    // eslint-disable-next-line react/no-array-index-key
                    <Row
                      key={k}
                      className={cn(
                        styles.div_line,
                        mapByShop[p.offer_id]?.status_flags?.is_check_size && styles.div_line_green,
                      )}
                    >
                      <Input
                        value={((mapByShop[p.offer_id] || { sizes_package: {} }).sizes_package || {}).height}
                        onBlur={(v) => onChange(p.offer_id, order.shop, 'height', v)}
                        center
                      />
                    </Row>
                  ))}
                </Column>
              </TableCell>
              <TableCell width={WIDTH_OZON_ORDERS[7]}>
                <Column>
                  {order.products.map((p, k) => (
                    // eslint-disable-next-line react/no-array-index-key
                    <Row
                      key={k}
                      className={cn(
                        styles.div_line,
                        mapByShop[p.offer_id]?.status_flags?.is_check_size && styles.div_line_green,
                      )}
                    >
                      <Input
                        value={((mapByShop[p.offer_id] || { sizes_package: {} }).sizes_package || {}).width}
                        onBlur={(v) => onChange(p.offer_id, order.shop, 'width', v)}
                        center
                      />
                    </Row>
                  ))}
                </Column>
              </TableCell>
              <TableCell width={WIDTH_OZON_ORDERS[7]}>
                <Column>
                  {order.products.map((p, k) => (
                    // eslint-disable-next-line react/no-array-index-key
                    <Row
                      key={k}
                      className={cn(
                        styles.div_line,
                        mapByShop[p.offer_id]?.status_flags?.is_check_size && styles.div_line_green,
                      )}
                    >
                      {' '}
                      <Input
                        value={((mapByShop[p.offer_id] || { sizes_package: {} }).sizes_package || {}).volume}
                        center
                        readOnly
                      />
                    </Row>
                  ))}
                </Column>
              </TableCell>
              <TableCell width={WIDTH_OZON_ORDERS[7]} center>
                <Column style={{ alignItems: 'center' }}>
                  {order.products.map((p, k) => (
                    // eslint-disable-next-line react/no-array-index-key
                    <div key={k} className={styles.div_line}>
                      <CheckButton
                        disabled={!mapByShop[p.offer_id]}
                        checked={mapByShop[p.offer_id]?.status_flags?.is_check_size}
                        onSelect={() => {
                          console.log(p.offer_id, 'is_check_size', !mapByShop[p.offer_id]?.status_flags?.is_check_size);
                          onChange(p.offer_id, order.shop, 'is_check_size', !mapByShop[p.offer_id]?.status_flags?.is_check_size);
                        }}
                      />
                    </div>
                  ))}
                </Column>
              </TableCell>
              <TableCell width={WIDTH_OZON_ORDERS[5]}>
                <Column style={{ alignItems: 'center' }}>
                  {order.products.map((p, k) => (
                    // eslint-disable-next-line react/no-array-index-key
                    <div key={k} className={styles.div_line}>
                      <ProviderList
                        selectProviderId={(mapByShop[p.offer_id] || {}).provider_id}
                        onSelect={(v) => onChange(p.offer_id, order.shop, 'provider_id', v.id)}
                      />
                    </div>
                  ))}
                </Column>
              </TableCell>
              <TableCell width={WIDTH_OZON_ORDERS[6]}>
                <Column>
                  {order.products.map((p, k) => (
                    <div key={k} className={styles.div_line}>
                      <Input
                        value={(mapByShop[p.offer_id] || {}).provider_artnumber}
                        onBlur={(v) => onChange(p.offer_id, order.shop, 'provider_artnumber', v)}
                        center
                      />
                    </div>
                  ))}
                </Column>
              </TableCell>

              <TableCell width={WIDTH_OZON_ORDERS[6]}>
                <Column>
                  {order.products.map((p, k) => (
                    <div key={k} className={styles.div_line}>
                      <Input
                        value={(mapByShop[p.offer_id] || {}).quantity}
                        onBlur={(v) => onChange(p.offer_id, order.shop, 'quantity', v)}
                        center
                      />
                    </div>
                  ))}
                </Column>
              </TableCell>
            </TableLine>
          )
        })}
      </Table>
      {isViewerOpen && <ImageViewer src={images} currentIndex={0} onClose={closeImageViewer} />}
    </>
  );
};

export default OzonTableSizes;
